import React, { ReactElement, useEffect, useState } from 'react';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { HeadingCaption } from 'idsk-react-components';
import GlobalErrors from '../../../module/GlobalErrors';
import routes from '../../../routing/routes';
import LegislativnyMaterialCreate
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialCreateUpdate/LegislativnyMaterialCreate';
import Layout from '../../Layout';
import { UserRoleEnum } from '../../../model/currentuser/UserRole';
import SecuredPage from '../../../module/SecuredPage';
import useHistoryPageContext from '../../../context/BreadcrumbContext/hook/useHistoryPageContext';
import homeBreadcrumbButton from './components/homeBreadcrumbButton';

const LegislativnyMaterialCreatePage = (): ReactElement => {
  const [pageStatus, setPageStatus] = useState<number>(null);
  const { setHistoryPages } = useHistoryPageContext();
  useEffect(() => {
    setHistoryPages([]);
  }, [setHistoryPages]);
  const [isBlocked, setIsBlocked] = useState<boolean>(false);

  useEffect(() => {
    const messageHandler = (message: MessageEvent): void => {
      if (message.data?.type === 'blockNavigation') {
        setIsBlocked(message.data.value);
      }
    };

    window.addEventListener('message', messageHandler);

    return () => {
      window.removeEventListener('message', messageHandler);
    };
  }, []);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        isBlocked ? homeBreadcrumbButton
          : homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        { to: routes.procesy.list, heading: 'Legislatívne procesy' },
        { to: routes.procesy.new, heading: 'Vytvorenie legislatívneho procesu' },
      ]}
      />
      <GlobalErrors />
      <SecuredPage
        allowForRoles={[UserRoleEnum.PREDKLADATEL_LEG, UserRoleEnum.PREDKLADATEL_NELEG]}
        requestStatus={pageStatus}
      >
        <>
          <HeadingCaption size="xl">Vytvorenie legislatívneho procesu</HeadingCaption>
          <LegislativnyMaterialCreate setPageStatus={setPageStatus} />
        </>
      </SecuredPage>
    </Layout>
  );
};

export default LegislativnyMaterialCreatePage;
